/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrgaAiTools {
    None = '0',
    KnowledgeSearch = 1,
    Documents = 2,
    Issues = 4,
    Charts = 8,
    WebSearch = 16,
    All = 31,
}
